// extracted by mini-css-extract-plugin
export var divider = "Divider-module--divider--C6zCV";
export var link = "Divider-module--link--3gbwL";
export var icon = "Divider-module--icon--34AWi";